var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    width: 40,
    height: 40,
    rx: 20,
    transform: "rotate(90 40 0)",
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 23C19.8028 23 19.6057 22.928 19.4554 22.7842L14.7257 18.2583C14.4248 17.9704 14.4248 17.5036 14.7257 17.2158C15.0264 16.9281 15.5141 16.9281 15.815 17.2158L20 21.2206L24.185 17.216C24.4858 16.9282 24.9735 16.9282 25.2742 17.216C25.5753 17.5038 25.5753 17.9706 25.2742 18.2585L20.5445 22.7844C20.3942 22.9281 20.1971 23 20 23Z",
    fill: "#4D525C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseArrow);
export default __webpack_public_path__ + "static/media/collapse-arrow.18424f90efa28b71a77754843434482b.svg";
export { ForwardRef as ReactComponent };